export default __webpack_public_path__ + "static/media/waterIcon.b7b2c02f.svg";